(() => {
  const states = {
    'not-started': { hero: 'notStartedMessage', social: 'notStartedSocial', awards: 'notStartedAwards', heroLabel: 'previewCta', heroHref: '#steps', awardLabel: 'previewCta', copy: true },
    open: { hero: 'openMessage', social: 'openSocial', awards: 'openAwards', heroLabel: 'openCta', heroHref: '#awards', awardLabel: 'openCta', copy: true },
    closed: { hero: 'closedMessage', social: 'closedSocial', awards: 'closedAwards', heroLabel: 'closedCta', heroHref: '#awards', awardLabel: 'closedCta', copy: false },
    results: { hero: 'resultsMessage', social: 'resultsSocial', awards: 'resultsAwards', heroLabel: 'resultsCta', heroHref: '#awards', awardLabel: 'resultsCta', copy: false }
  };

  function config() {
    const node = document.querySelector('[data-flyway-state-config]');
    if (!node) return null;
    const requested = new URLSearchParams(location.search).get('state');
    const state = node.dataset.designMode === 'true' && states[requested] ? requested : node.dataset.state;
    return { node, state: states[state] ? state : 'not-started', hashtag: node.dataset.hashtag || '#COOLFLYFlyway' };
  }

  function setText(selector, value) { document.querySelectorAll(selector).forEach((node) => { node.textContent = value; }); }
  function setLink(node, label, href, enabled = true) {
    if (!node) return;
    node.firstChild.textContent = `${label} `;
    if (enabled) { node.href = href; node.removeAttribute('aria-disabled'); } else { node.removeAttribute('href'); node.setAttribute('aria-disabled', 'true'); }
  }

  function applyState() {
    const current = config();
    if (!current) return;
    const state = states[current.state];
    const join = document.querySelector('[data-fw-join]');
    const awards = document.querySelector('[data-fw-awards]');
    document.documentElement.dataset.flywayState = current.state;
    setText('[data-fw-role="hero-state"]', current.node.dataset[state.hero]);
    setText('[data-fw-role="social-state"]', join?.dataset[state.social] || '');
    setText('[data-fw-role="awards-state"]', awards?.dataset[state.awards] || '');
    setLink(document.querySelector('[data-fw-role="hero-cta"]'), current.node.dataset[state.heroLabel] || '', state.heroHref);
    setLink(document.querySelector('[data-fw-role="award-cta"]'), awards?.dataset[state.awardLabel] || '', '#steps', state.copy);
    document.querySelectorAll('.fw-copy-button').forEach((button) => { button.disabled = !state.copy; });
  }

  function toast(message) {
    const node = document.querySelector('[data-fw-role="toast"]');
    if (!node) return;
    node.textContent = message; node.classList.add('is-visible'); clearTimeout(toast.timer);
    toast.timer = setTimeout(() => node.classList.remove('is-visible'), 2000);
  }

  function selectHashtag() {
    const code = document.querySelector('[data-fw-role="hashtag"]');
    if (!code) return;
    const range = document.createRange(); range.selectNodeContents(code);
    const selection = getSelection(); selection.removeAllRanges(); selection.addRange(range);
  }

  async function copyTag(button) {
    const current = config(); if (!current) return;
    const status = button.closest('.fw-social-card').querySelector('.fw-copy-status');
    try {
      await navigator.clipboard.writeText(current.hashtag);
      button.textContent = 'Copied!'; status.textContent = 'Copied!'; toast('Copied!');
      setTimeout(() => { button.textContent = 'Copy tag'; status.textContent = ''; }, 2000);
    } catch (_) {
      selectHashtag(); status.textContent = `Select and copy: ${current.hashtag}`; toast(`Select and copy: ${current.hashtag}`);
    }
  }

  function openRules(event) {
    if (event) event.preventDefault();
    const rules = document.querySelector('#full-rules'); if (!rules) return;
    rules.open = true; rules.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (location.hash !== '#full-rules') history.replaceState(null, '', '#full-rules');
  }

  function init(root = document) {
    root.querySelectorAll('.fw-copy-button:not([data-fw-bound])').forEach((button) => { button.dataset.fwBound = 'true'; button.addEventListener('click', () => copyTag(button)); });
    const videos = [...document.querySelectorAll('.fw-video-frame video')];
    videos.forEach((video) => { if (video.dataset.fwBound) return; video.dataset.fwBound = 'true'; video.addEventListener('play', () => videos.forEach((other) => { if (other !== video) other.pause(); })); video.addEventListener('error', () => video.closest('.fw-video-frame').classList.add('has-error')); });
    root.querySelectorAll('[data-fw-open-app]:not([data-fw-bound])').forEach((button) => { button.dataset.fwBound = 'true'; button.addEventListener('click', () => document.querySelector('[data-fw-dialog]')?.showModal()); });
    root.querySelectorAll('[data-fw-close-app]:not([data-fw-bound])').forEach((button) => { button.dataset.fwBound = 'true'; button.addEventListener('click', () => button.closest('dialog')?.close()); });
    root.querySelectorAll('[data-fw-open-rules]:not([data-fw-bound])').forEach((link) => { link.dataset.fwBound = 'true'; link.addEventListener('click', openRules); });
    const dialog = root.querySelector('[data-fw-dialog]'); if (dialog && !dialog.dataset.fwBound) { dialog.dataset.fwBound = 'true'; dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); }); }
    applyState(); if (location.hash === '#full-rules') openRules();
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('hashchange', () => { if (location.hash === '#full-rules') openRules(); });
})();
